import { useData } from 'vike-react/useData';

import { getAudienceById } from '@shared/constants/audiences';

import { Container } from '../../components/layout/Container';

import { Reveal } from '../../components/motion/Reveal';

import { StaggerGrid, StaggerItem } from '../../components/motion/StaggerGrid';

import { BreadcrumbListLd } from '../../components/seo/jsonld/BreadcrumbList';

import { JourneyTimeline } from '../../components/blocks/JourneyTimeline';

import { ToolsForAudience } from '../../components/blocks/ToolsForAudience';

import { ConcreteCase } from '../../components/blocks/ConcreteCase';

import { SectorHero } from '../../components/sector/SectorHero';

import { SectorProof } from '../../components/sector/SectorProof';

import { RecommendedCeeFiches } from '../../components/sector/RecommendedCeeFiches';

import { SectorFAQ } from '../../components/sector/SectorFAQ';

import { SectorCTA } from '../../components/sector/SectorCTA';

import { getAudienceVoice, COPROPRIETES_AIDES } from '../../config/audience-voice';

import { audienceLegacyTone } from '../../config/audience-theme';

import type { Data } from './+data';



const AUDIENCE_ID = 'coproprietes' as const;







export default function CoproprietesPage() {

  const { journey, tools, cases, ceeFiches } = useData<Data>();

  const audience = getAudienceById(AUDIENCE_ID)!;

  const voice = getAudienceVoice(AUDIENCE_ID);

  const legacyTone = audienceLegacyTone(AUDIENCE_ID);



  return (

    <>

      <BreadcrumbListLd

        items={[

          { name: 'Accueil', url: 'https://solutionecofrance.fr/' },

          { name: 'Copropriétés', url: 'https://solutionecofrance.fr/coproprietes' },

        ]}

      />



      <SectorHero

        audience={audience}

        voice={voice}

        promiseList={[

          { label: "MaPrimeRénov’ Copro", value: "jusqu'à 30 %", tone: 'brand' },

          { label: 'Primes énergie (CEE) collectives', value: '+ bonifications', tone: 'accent' },

          { label: 'Éco-prêt à taux zéro (éco-PTZ) collectif', value: "jusqu'à 50 000 €/lot", tone: 'ink' },

          { label: 'Présentation en AG', value: 'offerte', tone: 'brand' },

        ]}

      />



      <SectorProof audience={audience} voice={voice} variant="bento" />



      {journey && (

        <JourneyTimeline

          eyebrow={voice.method.eyebrow}

          title={voice.method.title}

          description={voice.method.description}

          totalDuration={journey.totalDuration}

          ctaLabel={journey.ctaLabel}

          ctaHref={journey.ctaHref}

          steps={journey.steps}

          tone={legacyTone}

        />

      )}



      {/* AIDES CUMULABLES — spécifique copropriétés */}

      <section className="bg-stone-50/50 py-16 md:py-20">

        <Container>

          <Reveal>

            <div className="mx-auto mb-10 max-w-xl text-center">

              <p className="eyebrow justify-center">Aides cumulables Copro</p>

              <h2 className="mt-3 h-section">Quatre dispositifs cumulés pour réduire la quote-part.</h2>

            </div>

          </Reveal>



          <StaggerGrid className="mx-auto grid max-w-5xl gap-3 sm:grid-cols-2 lg:grid-cols-4">

            {COPROPRIETES_AIDES.map((a) => (

              <StaggerItem

                key={a.label}

                className="rounded-xl border border-stone-200/70 bg-paper p-5 transition-all duration-150 ease-out hover:-translate-y-0.5 hover:shadow-elevated"

              >

                <div

                  className={`inline-flex h-9 w-9 items-center justify-center rounded-lg text-sm font-semibold ${

                    a.color === 'brand'

                      ? 'bg-brand-50 text-brand-700'

                      : a.color === 'accent'

                        ? 'bg-accent-50 text-accent-800'

                        : a.color === 'lavender'

                          ? 'bg-lavender-50 text-lavender-700'

                          : 'bg-sage-100 text-sage-500'

                  }`}

                >

                  €

                </div>

                <p className="mt-3 h-card">{a.label}</p>

                <p className="mt-1 text-[11px] text-stone-500 leading-relaxed">{a.sub}</p>

              </StaggerItem>

            ))}

          </StaggerGrid>

        </Container>

      </section>



      {tools.length > 0 && (

        <ToolsForAudience

          eyebrow={voice.tools.eyebrow}

          title={voice.tools.title}

          description={voice.tools.description}

          tools={tools.map((t) => ({

            title: t.title,

            description: t.description,

            iconName: t.iconName,

            href: t.href,

            badge: t.badge,

            metric: t.metric,

            metricLabel: t.metricLabel,

          }))}

          tone={legacyTone}

        />

      )}



      <RecommendedCeeFiches audience={audience} fiches={ceeFiches} />



      {cases.length > 0 && (

        <ConcreteCase

          eyebrow={voice.caseStudy.eyebrow}

          title={voice.caseStudy.title}

          cases={cases}

          tone={legacyTone}

        />

      )}



      <SectorFAQ audience={audience} voice={voice} />



      <SectorCTA audience={audience} voice={voice} />

    </>

  );

}

